"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * React hook to simplifying asynchronous data 
 * workflows with loading and error states
 *
 * @package HOPS
 * @subpackage Hooks
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
const useData = fetcher => {
  const [data, setData] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(true);

  /**
   * Actual data fetcher
   */
  const fetch = (0, _react.useCallback)(async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await fetcher();
      setData(data);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  }, [fetcher]);

  /**
   * Fetch immediately on first render
   */
  (0, _react.useEffect)(() => {
    fetch();
  }, [fetch]);

  /**
   * Return value.
   */
  return (0, _react.useMemo)(() => {
    return {
      data,
      setData,
      error,
      setError,
      loading,
      setLoading,
      fetch
    };
  }, [data, setData, error, setError, loading, setLoading, fetch]);
};
var _default = exports.default = useData;